module.exports = __webpack_public_path__ + "img/28_newYouth_xsy.eedfacf7.png";